import { letsGo } from '@assets'

import { useChatContext } from '../ChatProvider'

export default function EmptyChat() {
	const { user } = useChatContext()

	return (
		<div className='relative h-full w-full transition-width flex flex-col overflow-hidden items-stretch flex-1'>
			<div className='w-3/4 mx-auto text-slate-500 mt-10'>
				<div>
					<h2 className='text-2xl font-bold mb-4 text-center'>👋 Hello { user?.name } !</h2>
					<div className='mt-10 w-[600px] mx-auto'>
						<ul className='list-disc list-inside space-y-8'>
							<li>
								<span className='font-semibold'>Choose the right “Brain”</span>
								<p>Each Brain is a corpus of documents. You can select one or several at a time to cross-reference the data.</p>
							</li>
							<li>
								<span className='font-semibold'>Specify the right “Output”</span>
								<p>With each question, it is essential to clearly define what you want as an output (e.g. a list of names, a table with specific columns, a short synthesis, etc.)</p>
							</li>
							<li>
								<span className='font-semibold'>Provide the correct “Context”</span>
								<p>What are we specifically talking about? Use keywords that you would likely find in the source documents.</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className='w-[660px] mx-auto mt-auto'>
				<img className='h-16 ml-auto ' src={ letsGo } />
			</div>
		</div>
	)
}
